import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-my-classes',
  templateUrl: './student-my-classes.component.html',
  styleUrls: ['./student-my-classes.component.css']
})
export class StudentMyClassesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
